<div class="mh animate__animated animate__fadeIn"
     [ngClass.gt-xs]="'px-5 py-2'"
     [ngClass.xs]="'p-2'"
     fxLayout="row"
     fxLayoutAlign="space-between">
  <div fxLayout="column"
       fxLayoutAlign="space-around">
    <div class="mh__module-name mb-2"
         fxLayout="row"
         fxLayoutAlign="start start">
      <mat-icon class="mr-1">{{moduleIcon}}</mat-icon>
      <span>{{moduleName}} </span>
      <span fxHide.gt-xs
            class="mh__module-title"> - {{title}}</span>
    </div>
    <div class="mh__route-title"
         fxHide.xs>
      <div class="mh__route-title-itens">
        <span class="mh__route-title-itens-home"
              (click)="goHome()">Home</span>
        <mat-icon>arrow_forward_ios</mat-icon>
        <span>{{title}}</span>
      </div>
    </div>
  </div>
  <div fxHide.xs
       fxLayout="column"
       fxLayoutAlign="center">
    <img class="mh__logo"
         src="../../../../assets/images/png/logo.png" />
  </div>
</div>
